<div class="modal-header">
  <h4 class="modal-title mt-0" id="modal-basic-title">
    <span translate>{{ 'TRANSPORT_DETAILS' | translate }}</span
    >&nbsp;
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  @if (!isLoading) {
    <div class="row" [formGroup]="form">
      <div class="col-12">
        <lib-gung-text-input-horizontal
          formControlName="q_hl_logentcontactperson"
          gungTranslate="CONTACT_PERSON"
        ></lib-gung-text-input-horizontal>
      </div>

      <div class="col-12">
        <lib-gung-text-input-horizontal
          formControlName="q_hl_logentcontactdetails"
          gungTranslate="CONTACT_DETAILS"
        ></lib-gung-text-input-horizontal>
      </div>

      <div class="col-12">
        <lib-gung-text-input-horizontal
          formControlName="q_hl_logentdeliveryinstruction"
          gungTranslate="DELIVERY_INSTRUCTIONS"
        ></lib-gung-text-input-horizontal>
      </div>

      <div class="col-12">
        <div class="row">
          <div class="col-12 col-sm-4">
            <label class="col-form-label font-weight-bold">
              {{ 'DELIVERY_TIME_EARLIEST' | translate }}
            </label>
          </div>
          <div class="col">
            <input type="time" name="time" id="date" class="form-control" formControlName="q_hl_deliverytimeearliest" />
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="row">
          <div class="col-12 col-sm-4">
            <label class="col-form-label font-weight-bold">
              {{ 'DELIVERY_TIME_LATEST' | translate }}
            </label>
          </div>
          <div class="col">
            <input type="time" name="time" id="date" class="form-control" formControlName="q_hl_deliverytimelatest" />
          </div>
        </div>
      </div>
    </div>
  } @else {
    <div class="row">
      <div class="col-12 d-flex flex-row justify-content-center">
        <i class="fa fa-spinner fa-spin fa-5x"></i>
      </div>
    </div>
  }
</div>

<div class="modal-footer">
  <div class="d-flex flex-row" style="gap: 16px">
    <button type="button" class="btn btn-sm btn-primary pl-4 pr-4" (click)="onSave()" translate>SAVE</button>

    <button type="button" class="btn btn-sm btn-outline-primary pl-4 pr-4" (click)="close()" translate>CANCEL</button>
  </div>
</div>
